import { render } from "./CompensationRecord.vue?vue&type=template&id=3e526bc8&scoped=true"
import script from "./CompensationRecord.vue?vue&type=script&lang=js"
export * from "./CompensationRecord.vue?vue&type=script&lang=js"

import "./CompensationRecord.vue?vue&type=style&index=0&id=3e526bc8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e526bc8"]])

export default __exports__